import { Box, Switch, SwitchProps, styled } from "@mui/material";
import { Minus } from "lucide-react";

interface IMySwitchProps extends SwitchProps {
  indeterminate?: boolean;
}

const MySwitchBase = styled(Switch, {
  shouldForwardProp: (prop) => prop !== "indeterminate",
})<IMySwitchProps>(({ theme, indeterminate }) => ({
  padding: 8,
  "& .MuiSwitch-track": {
    borderRadius: 22 / 2,
    "&::before, &::after": {
      content: '""',
      position: "absolute",
      top: "50%",
      transform: "translateY(-50%)",
      width: 16,
      height: 16,
    },
    "&::before": {
      left: 12,
    },
    "&::after": {
      right: 12,
    },
  },
  "& .MuiSwitch-thumb": {
    boxShadow: "none",
    width: 16,
    height: 16,
    margin: 2,
  },
  ...(indeterminate && {
    "& .MuiSwitch-switchBase": {
      color: theme.palette.common.white,
      "& + .MuiSwitch-track": {
        backgroundColor: `${theme.palette.primary.light} !important`,
        opacity: 1,
      },
    },
    "& .MuiSwitch-thumb": {
      opacity: 0,
    },
  }),
}));

const IndeterminateIcon = styled(Minus)({
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 14,
  height: 14,
  color: "#fff",
  pointerEvents: "none",
});

const MySwitch: React.FC<IMySwitchProps> = ({ indeterminate, ...props }) => (
  <Box sx={{ position: "relative", display: "inline-flex" }}>
    <MySwitchBase indeterminate={indeterminate} {...props} />
    {indeterminate && <IndeterminateIcon />}
  </Box>
);

export default MySwitch;
